import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.0.10_@babel+core@7.28.5_@opentelemetry+api@1.9.0_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["PlyrVideoPlayer"] */ "/vercel/path0/src/components/video/plyr-video-player.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LessonNavigation"] */ "/vercel/path0/src/features/courses/components/lesson-navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LessonProgressActions"] */ "/vercel/path0/src/features/courses/components/lesson-progress-actions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoProgressReporter"] */ "/vercel/path0/src/features/courses/components/video-progress-reporter.tsx");
